
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import Button from '../../../core/components/Generics/Button.vue';
import { ClaimsApi } from '../../../core/api/ClaimsApi';
import { showErrorSnackbar, showSuccessSnackbar } from '../../../../features/helpers/alerts-popups';
import { NDVIInfo, SatellitalLayersInfo, ZonificationInfo } from '../../../../features/typescript/satellital/layers';
import ModalNdviDiff from '../sinisters/modals/ModalNdviDiff.vue';
import { SatellitalImage } from '../../../../features/typescript/satellital/satellital_images';
import ModalZonification from '../sinisters/modals/ModalZonification.vue';
@Component({
  components: {
    SimpleMap,
    ModalNdviDiff,
    ModalZonification,
    Button
  },
})
export default class SinisterActions extends Vue {
  @Prop({default: null}) zonifiedDate: string | null
  @Prop({default: null}) selectedImage: SatellitalImage;
  @Prop({default() {return []}}) bandImages: SatellitalImage[];
  @Prop({default: null}) currentSatellitalImage: SatellitalImage | null;
  @Prop({default: -1}) id: number;
  @Prop({default: false}) editPolygonModalVisible: boolean;
  @Prop({default: false}) createItemModalVisible: boolean;
  @Prop({default: false}) applyingRestorePolygon: boolean;
  @Prop({default: {
       initial_date: null,
       final_date: null,
       bar_url: '',
       png_url: null,
       total_area: null,
       zones: [],
       bounds: null
  }}) diffInfo: NDVIInfo | null;
  @Prop({default: {
      date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
    }}) zonifiedInfo: ZonificationInfo | null;
  @Prop({default: null}) selectedBand: string | null;
  applyingZonification: boolean = false;
  applyingNdviDiff: boolean = false;
  visibleModalNdviDiff: boolean = false;
  visibleZonificationModal: boolean = false;

  get disableActionsForRgb(){
    if(this.selectedBand === null) return true;
    return this.selectedBand !== 'NDVI'
  }

  get canTriggerZonification(){
    return this.selectedImage !== null && this.selectedBand === 'NDVI'
  }

  get canTriggerNdviDiff(){
    return this.bandImages.length > 0 && this.selectedBand === 'NDVI'
  }

  applyNdviDiff(data){
    this.visibleModalNdviDiff = false;
    this.applyingNdviDiff = true;
    this.processingNdviDiff(true)
    let config = {
      id: this.id, 
      ...data
    }
    ClaimsApi.postNdviDiff(
      config
    ).then((res) => {
      this.updateNdviInfo(res.ndvi);
      showSuccessSnackbar(res.message);
    }).catch((error) => {
      let msg = error && error.response && error.response.data && error.response.data.message || 'No se pudo generar el Diferencial NDVI';
      showErrorSnackbar(msg)
    }).finally(() => {
      this.processingNdviDiff(false)
      this.applyingNdviDiff = false;
    })
  }

  applyZonification(data){
    
    if(this.currentSatellitalImage === null) return;

    this.applyingZonification = true;
    let config = {
      id: this.id, 
      ...data
    }
    this.visibleZonificationModal = false;
    this.processingZonification(true);
    ClaimsApi.postZonification(
      config
    ).then((res) => {
      this.updateZonifiedInfo(res.zonified);
      showSuccessSnackbar(res.message);
    }).catch((err) => {
      let msg = err && err.response && err.response.data && err.response.data.message || 'No se pudo generar la zonificación';
      showErrorSnackbar(msg)
    }).finally(() => {
       this.processingZonification(false);
      this.applyingZonification = false;
    })
  }

  @Emit()
  processingZonification(value: boolean){}

  @Emit()
  processingNdviDiff(value: boolean){}

  @Emit()
  updateZonifiedInfo(info: ZonificationInfo){}

  @Emit()
  updateNdviInfo(ndvi_info: NDVIInfo){}
  
}
